const Day = ({ value, isSelected, isSelectedDashed, isSuccess, isWarning, isDisabled, isWeekend, onClick, isCanceled = false, isSubstituted = false, isToday = false, isOnlySubstitute = false }) => {
    return (
        <div 
            className={`day ${isSelected ? "selected-solid" : ""} ${isCanceled ? "canceled" : ""} ${isSubstituted ? "substitute" : ""}  ${isSelectedDashed ? "selected-dashed" : ""} ${isSuccess ? "notification-success" : ""} ${isWarning ? "notification-warning" : ""} ${isDisabled ? "disabled" : ""} ${isWarning ? "notification-warning" : ""} ${isWeekend ? "weekend" : ""} ${isToday ? "today" : ""} ${isOnlySubstitute ? "isOnlySubstitute" : ""}`}
            onClick={onClick}
        >
            {value}
        </div>
    );
};

export default Day;
